export enum UpdateActions {
    update = 'update',
    update_save = 'update-save',
    save = 'save',
    saveHtml = 'save-html',
    omit = 'omit-check'
}

export enum RecordEditState {
    default = 0,
    edit = 1,
    update = 2,
    error = 3,
    shouldUpdate = 4
}

export enum FormMetaStoreKeys {
    customColumnsWidth = 'customColumnsWidth',
    fixedColumns = 'fixedColumns',
    tableHeight = 'tableHeight',
    formView = 'formView'
}
